import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "bgConstructorAddFloorOrWall"
}
const _hoisted_2 = { class: "bgConstructorAddFloorOrWall__body" }
const _hoisted_3 = { class: "bgConstructorAddFloorOrWall__buttons" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "bgConstructorAddFloorOrWall__name" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "bgConstructorAddFloorOrWall__nameInput" }
const _hoisted_10 = { class: "bgConstructorAddFloorOrWall__files" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(": ")
const _hoisted_13 = { key: 1 }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(": ")
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = {
  key: 0,
  class: "bgConstructorAddFloorOrWall__button p-button p-component"
}
const _hoisted_18 = ["onChange"]
const _hoisted_19 = {
  key: 1,
  class: "bgConstructorAddFloorOrWall__button p-button p-component p-button-raised p-button-secondary p-button-text"
}
const _hoisted_20 = ["onChange"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_ctx.uploadedFiles && _ctx.uploadedFiles.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_Button, {
              onClick: _cache[0] || (_cache[0] = () => _ctx.uploadSelectedFiles()),
              class: "p-button p-component",
              disabled: _ctx.areSelectedFileUploading || !_ctx.areAllFilesAdded || !_ctx.name
            }, {
              default: _withCtx(() => [
                (!_ctx.areSelectedFileUploading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                      _createElementVNode("span", null, _toDisplayString(_ctx.$t('bg_constructor.upload')), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.areSelectedFileUploading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.$t('bg_constructor.uploading')), 1))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["disabled"]),
            _createVNode(_component_Button, {
              onClick: _cache[1] || (_cache[1] = () => _ctx.cancelUploadingFiles()),
              class: "p-button p-component p-button-raised p-button-secondary p-button-text"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('bg_constructor.cancel')), 1)
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("label", null, [
              (_ctx.target == 'wall')
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.$t('bg_constructor.wall_name')), 1))
                : _createCommentVNode("", true),
              (_ctx.target == 'floor')
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.$t('bg_constructor.floor_name')), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.name) = $event))
              }, null, 512), [
                [_vModelText, _ctx.name]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("label", null, [
              (_ctx.target == 'wall')
                ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.$t('bg_constructor.wall_images')), 1))
                : _createCommentVNode("", true),
              _hoisted_12,
              (_ctx.target == 'floor')
                ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.$t('bg_constructor.floor_images')), 1))
                : _createCommentVNode("", true),
              _hoisted_14
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.uploadedFiles, (file) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "bgConstructorAddFloorOrWall__file",
                key: file.name
              }, [
                _createElementVNode("div", {
                  class: "bgConstructorAddFloorOrWall__filePreview",
                  style: _normalizeStyle({
              backgroundImage: 'url(' + file.filePreview + ')'
            })
                }, [
                  (!file.file)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(file.name), 1))
                    : _createCommentVNode("", true),
                  (!file.file)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_ctx.$t('bg_constructor.no_file')), 1))
                    : _createCommentVNode("", true)
                ], 4),
                (!file.file)
                  ? (_openBlock(), _createElementBlock("a", _hoisted_17, [
                      _createElementVNode("label", null, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t('bg_constructor.set_file')), 1),
                        _createElementVNode("input", {
                          type: "file",
                          onChange: (e) => _ctx.replaceUploadedFile(file, e)
                        }, null, 40, _hoisted_18)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (file.file)
                  ? (_openBlock(), _createElementBlock("a", _hoisted_19, [
                      _createElementVNode("label", null, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t('bg_constructor.replace_file')), 1),
                        _createElementVNode("input", {
                          type: "file",
                          onChange: (e) => _ctx.replaceUploadedFile(file, e)
                        }, null, 40, _hoisted_20)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}